var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-container"},[_c('client-only',[_c('VueSlider',{attrs:{"enable-cross":false,"marks":_vm.marks,"contained":true,"min":_vm.min,"max":_vm.max,"tooltip-placement":'bottom',"tooltip":_vm.tooltip,"rail-style":{
        backgroundColor: '#F5F7F8',
        height: '10px',
        borderRadius: '2px'
      },"dot-style":{
        backgroundColor: '#23CD9A',
        width: '6px',
        borderRadius: '1px',
        boxShadow: 'none'
      },"process-style":{
        backgroundColor: '#000000',
        borderRadius: '0px'
      },"tooltip-style":{
        backgroundColor: '#000000',
        borderColor: '#000000',
        padding: '2px 4px',
        color: '#ffffff',
        fontSize: '10px',
        borderRadius: '2px'
      },"label-style":{
        display: 'none'
        // fontSize: '1rem'
      },"silent":"","min-range":_vm.minRangeValue},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})],1),_vm._v(" "),_c('div',{staticClass:"range-container"},[_c('span',[_vm._v(_vm._s(_vm.formatRange.min))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatRange.max))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }